/* assets/rfcartdrawer.js */
(function () {
  // El envío ya es gratis siempre (desde 1 unidad), así que esta barra ya
  // no tiene sentido usarla para eso. La reusamos para incentivar llegar a
  // 2 unidades, que es donde se desbloquea el -10%, la guía de regalo y las
  // 3 cuotas sin interés.
  var PROMO_UNITS = 2;

  // Número de la barra negra de arriba. Cambialo por tu cantidad REAL de clientas.
  var PROOF_NUMBER = '1.200';
  var TRASH = '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';
  var CLOCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#0F5C56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></svg>';

  // Estilo del botón "Pago seguro"
  var style = document.createElement('style');
  style.textContent =
    '#rf-checkout-btn {' +
    '  border-radius: 14px !important;' +
    '  font-family: "Poppins", "DM Sans", system-ui, -apple-system, sans-serif !important;' +
    '  font-size: 15px !important;' +
    '  font-weight: 700 !important;' +
    '  letter-spacing: 0.03em !important;' +
    '  display: flex !important;' +
    '  align-items: center !important;' +
    '  justify-content: center !important;' +
    '  gap: 8px !important;' +
    '}';
  document.head.appendChild(style);

  function unitLabel(n) {
    return n === 1 ? 'unidad' : 'unidades';
  }

  var drawer = document.getElementById('rf-cart-drawer');
  if (!drawer) return;

  var itemsList = document.getElementById('rf-items-list');
  var subtotalEl = document.getElementById('rf-subtotal-amount');
  var shippingBox = document.getElementById('rf-shipping-box');
  var shippingText = document.getElementById('rf-shipping-text');
  var shippingBar = document.getElementById('rf-shipping-bar');
  var upsellItems = drawer.querySelectorAll('[data-rf-quick-add]');

  function money(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-AR', { minimumFractionDigits: 2 });
  }

  // Barra negra arriba de todo (estilo Dermapura) + "tu carrito te espera por" con temporizador.
  var panel = drawer.querySelector('.rf-drawer-panel');
  if (panel && !document.getElementById('rf-topbar')) {
    var top = document.createElement('div');
    top.id = 'rf-topbar';
    top.innerHTML = '✨ +' + PROOF_NUMBER + ' MUJERES YA LA USAN ✨';
    panel.insertBefore(top, panel.firstChild);
  }
  if (shippingBox && !document.getElementById('rf-proof')) {
    var proof = document.createElement('div');
    proof.id = 'rf-proof';
    proof.innerHTML =
      '<div class="rf-saved" id="rf-saved">' + CLOCK + '<span id="rf-saved-text"><b>Tu carrito te espera por:</b> <span id="rf-timer" class="rf-timer">10:00</span></span></div>';
    shippingBox.parentNode.insertBefore(proof, shippingBox);
  }

  function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }

  drawer.querySelectorAll('[data-rf-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Temporizador de 10 minutos "Tu carrito te espera por:".
  // Arranca cuando hay productos en el carrito y queda guardado en el navegador.
  // Al llegar a 00:00 NO borra nada: pasa a decir que el carrito sigue guardado.
  var TIMER_MINUTES = 10;
  var TIMER_KEY = 'rfCartDeadline';
  var timerId = null;
  function getDeadline() { try { return parseInt(localStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) { return 0; } }
  function setDeadline(v) { try { if (v) localStorage.setItem(TIMER_KEY, String(v)); else localStorage.removeItem(TIMER_KEY); } catch (e) {} }
  function tickTimer() {
    var saved = document.getElementById('rf-saved');
    var txt = document.getElementById('rf-saved-text');
    if (!saved || !txt) return;
    var left = getDeadline() - Date.now();
    if (left <= 0) {
      txt.innerHTML = '<b>Tu carrito sigue guardado</b>';
      clearInterval(timerId); timerId = null;
      return;
    }
    var s = Math.ceil(left / 1000);
    var m = Math.floor(s / 60);
    var r = s % 60;
    txt.innerHTML = '<b>Tu carrito te espera por:</b> <span id="rf-timer" class="rf-timer">' +
      (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r + '</span>';
  }
  function syncTimer(cart) {
    var saved = document.getElementById('rf-saved');
    if (!saved) return;
    if (cart.item_count === 0) {
      saved.style.display = 'none';
      setDeadline(0);
      if (timerId) { clearInterval(timerId); timerId = null; }
      return;
    }
    saved.style.display = '';
    if (!getDeadline()) setDeadline(Date.now() + TIMER_MINUTES * 60 * 1000);
    tickTimer();
    if (!timerId && getDeadline() > Date.now()) timerId = setInterval(tickTimer, 1000);
  }

  // Subtotal / Envío / Total (estilo Dermapura).
  function renderTotals(cart) {
    var subRow = subtotalEl ? subtotalEl.closest('.rf-subtotal') : null;
    if (!subRow) return;
    if (!document.getElementById('rf-ship-row')) {
      var ship = document.createElement('div');
      ship.id = 'rf-ship-row';
      ship.className = 'rf-line';
      ship.innerHTML = '<span>Envío</span><span class="rf-free">GRATIS</span>';
      var tot = document.createElement('div');
      tot.id = 'rf-total-row';
      tot.className = 'rf-line rf-total';
      tot.innerHTML = '<span>Total</span><span id="rf-total-amount"></span>';
      subRow.insertAdjacentElement('afterend', ship);
      ship.insertAdjacentElement('afterend', tot);
    }
    var t = document.getElementById('rf-total-amount');
    if (t) t.textContent = money(cart.total_price);
  }

 function renderItems(cart) {
    if (cart.items.length === 0) {
      itemsList.innerHTML =
        '<div class="rf-empty">' +
          '<p>Tu carrito está vacío.</p>' +
          '<a href="https://www.resurfia.com.ar/products/resurfia-triple-acido-corporal" class="rf-continue-btn">Seguir comprando</a>' +
        '</div>';
      return;
    }
    itemsList.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="rf-item">' +
          '<img src="' + (item.image || '') + '&width=140" alt="">' +
          '<div class="rf-item-info">' +
            '<p class="name">' + item.product_title + '</p>' +
            '<p class="price">' + money(item.final_line_price) + '</p>' +
          '</div>' +
          '<div class="rf-item-side">' +
            '<button type="button" class="rf-remove" data-rf-remove data-key="' + item.key + '" aria-label="Quitar producto">' + TRASH + '</button>' +
            '<div class="rf-qty">' +
              '<button type="button" data-rf-qty-change data-key="' + item.key + '" data-delta="-1">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-rf-qty-change data-key="' + item.key + '" data-delta="1">+</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    itemsList.querySelectorAll('[data-rf-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var currentItem = window.__rfCart.items.find(function (i) { return i.key === key; });
        if (!currentItem) return;
        updateQuantity(key, currentItem.quantity + delta);
      });
    });

    itemsList.querySelectorAll('[data-rf-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateQuantity(btn.getAttribute('data-key'), 0);
      });
    });
  }

 function renderShipping(cart) {
    if (cart.item_count === 0) {
      shippingBox.style.display = 'none';
      return;
    }
    shippingBox.style.display = '';
    var remainingUnits = PROMO_UNITS - cart.item_count;
    var pct = Math.max(0, Math.min(100, Math.round((cart.item_count / PROMO_UNITS) * 100)));
    shippingBar.style.width = pct + '%';
    if (remainingUnits <= 0) {
      shippingBox.classList.add('is-unlocked');
      shippingText.innerHTML = '🎉 ¡Descuento, tu Guía de Regalo y cuotas sin interés desbloqueados!';
    } else {
      shippingBox.classList.remove('is-unlocked');
      shippingText.innerHTML = 'Falta <strong>' + remainingUnits + ' ' + unitLabel(remainingUnits) + '</strong> para tu descuento, tu Guía de Regalo y cuotas';
    }
  }

  function renderUpsellState(cart) {
    var cartVariantIds = cart.items.map(function (i) { return String(i.variant_id); });
    upsellItems.forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (cartVariantIds.indexOf(variantId) > -1) {
        btn.textContent = 'Agregado';
        btn.classList.add('is-added');
      } else {
        btn.textContent = '+ Agregar';
        btn.classList.remove('is-added');
      }
    });
  }

  function renderAll(cart) {
    window.__rfCart = cart;
    // Carrito vacío: se oculta la barra de arriba, el pie y "Seguir mirando".
    drawer.classList.toggle('rf-is-empty', cart.items.length === 0);
    renderItems(cart);
    renderShipping(cart);
    renderUpsellState(cart);
    syncTimer(cart);
    renderTotals(cart);
    // Avisa a otros bloques (como la barra sticky de "Agregar al carrito")
    // que el carrito cambió, para que se actualicen sin pegarle de nuevo a /cart.js.
    document.dispatchEvent(new CustomEvent('rf:cart:updated', { detail: cart }));
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    var oldNote = drawer.querySelector('.rf-footer .note');
    if (oldNote) oldNote.style.display = 'none';
    var checkoutBtn = document.getElementById('rf-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.style.display = cart.items.length === 0 ? 'none' : '';
      // Candado (SVG blanco, no emoji) + texto, una sola vez.
      if (!checkoutBtn.querySelector('.rf-lock-icon')) {
        checkoutBtn.innerHTML =
          '<svg class="rf-lock-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="11" width="16" height="10" rx="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 11V7a5 5 0 0 1 10 0v4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span>' + checkoutBtn.textContent.trim() + '</span>';
      }
      if (cart.items.length > 0 && !document.getElementById('rf-keep-btn')) {
        var keep = document.createElement('button');
        keep.type = 'button';
        keep.id = 'rf-keep-btn';
        keep.textContent = 'Seguir mirando';
        keep.addEventListener('click', closeDrawer);
        checkoutBtn.insertAdjacentElement('afterend', keep);
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderAll);
  }

  function updateQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderAll);
  }

  function addVariant(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function () { return fetchCart(); })
      .then(openDrawer);
  }

  upsellItems.forEach(function (btn) {
    btn.addEventListener('click', function () {
      addVariant(btn.getAttribute('data-variant-id'));
    });
  });

  // Escucha cualquier "Agregar al carrito" existente en tu tema (formularios
  // de producto estándar de Shopify) para abrir el drawer después de agregar.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName === 'FORM' && form.action && form.action.indexOf('/cart/add') > -1) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function () { return fetchCart(); })
        .then(openDrawer);
    }
  }, true);

  window.rfOpenCartDrawer = openDrawer;
  window.rfCloseCartDrawer = closeDrawer;
  window.rfRefreshCart = fetchCart;

  fetchCart();
})();